// extracted by mini-css-extract-plugin
export var content = "WPBroadcastTeaser-module--content--PefyW";
export var date = "WPBroadcastTeaser-module--date--5oU2d";
export var excerpt = "WPBroadcastTeaser-module--excerpt--YpO8V";
export var image = "WPBroadcastTeaser-module--image --J4BJI";
export var teaser = "WPBroadcastTeaser-module--teaser--s2HT4";